import _cloneDeep from "lodash/cloneDeep";
import _isNil from "lodash/isNil";
/* eslint-disable no-param-reassign */
import produce, { original } from 'immer';
import { initialPlotConfigStates } from 'redux/reducers/componentConfig/initialState';
import { mergeObjectReplacingArrays } from 'utils/arrayUtils';
var configsReplaced = produce(function (draft, action) {
  var updatedConfigs = action.payload.updatedConfigs;
  var originalState = original(draft);
  updatedConfigs.forEach(function (_ref) {
    var _originalState$id;
    var id = _ref.id,
      updatedConfig = _ref.config;
    // If config is not loaded, no need to update it. The entry can exist with only
    // plot data in it, giving it a config here would make it look loaded.
    if (_isNil((_originalState$id = originalState[id]) === null || _originalState$id === void 0 ? void 0 : _originalState$id.config)) return;
    var plotType = originalState[id].plotType;
    var newConfig = mergeObjectReplacingArrays(_cloneDeep(initialPlotConfigStates[plotType]), updatedConfig);
    draft[id].config = newConfig;
  });
});
export default configsReplaced;